<script setup lang="ts">
import UploadToast from "@/components/files/UploadList/UploadToast.vue";
import SyncToast from "@/components/files/UploadList/SyncToast.vue";
</script>

<template>
  <div
    class="toast-container position-fixed bottom-0 end-0 m-3 d-flex flex-column gap-3"
  >
    <UploadToast />
    <SyncToast />
  </div>
</template>

<style lang="scss" scoped>
.toast-container {
  z-index: 100;
  max-width: 400px;
  pointer-events: none;

  > :deep(*) {
    pointer-events: auto;
  }
}
</style>
